var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembersToTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5914 20.485C13.4256 20.485 10.0486 17.108 10.0486 12.9422C10.0486 8.77645 13.4256 5.39941 17.5914 5.39941C21.7572 5.39941 25.1342 8.77645 25.1342 12.9422C25.1342 17.108 21.7572 20.485 17.5914 20.485Z",
    fill: "#F46350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2771 19.4851C30.4999 19.4851 28.2485 17.2337 28.2485 14.4565C28.2485 11.6793 30.4999 9.42798 33.2771 9.42798C36.0543 9.42798 38.3056 11.6793 38.3056 14.4565C38.3056 17.2337 36.0543 19.4851 33.2771 19.4851Z",
    fill: "#F46350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39999 38.6374C4.39999 39.1764 4.71947 39.5999 5.12607 39.5999H30.0739C30.4805 39.5999 30.8 39.1764 30.8 38.6374C30.8 30.668 24.8752 24.2 17.6 24.2C10.3247 24.2 4.39999 30.668 4.39999 38.6374Z",
    fill: "#F46350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9539 31.3669C24.9539 31.7214 25.1553 31.9999 25.4117 31.9999H41.1421C41.3985 31.9999 41.5999 31.7214 41.5999 31.3669C41.5999 26.1259 37.8642 21.8723 33.2769 21.8723C28.6896 21.8723 24.9539 26.1259 24.9539 31.3669Z",
    fill: "#F46350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersToTeam);
export default __webpack_public_path__ + "static/media/MembersToTeam.04ada6203a6d748a675e002fa1d1db57.svg";
export { ForwardRef as ReactComponent };